<template>
  <div>
    <v-dialog v-model="hideShow" width="960px" persistent scrollable content-class="approve-record-dialog" aria-label="核销课时">
      <v-card class="ar-shell">
        <v-card-title class="ar-header">
          <span class="ar-symbol"><v-icon size="26" color="#d9363e">mdi-clipboard-check-outline</v-icon></span>
          <div class="ar-heading"><h2>核销课时</h2><p>核对学员到课情况与本次扣除，确认后提交核销</p></div>
          <span v-if="!loadding" class="ar-count"><strong>{{approve.studentList.length}}</strong><span>位学员</span></span>
          <v-btn icon aria-label="关闭核销课时" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="ar-body">
          <div class="ar-list-heading"><h3>学员点名</h3><span><v-icon size="15">mdi-pencil-outline</v-icon>可逐项修改本次课时和上课状态</span></div>
          <v-data-table class="ar-table" :headers="approve.headers" :items="approve.studentList" disable-pagination hide-default-footer fixed-header item-key="id" :loading="loadding" :mobile-breakpoint="0" loading-text="正在加载，请稍候…" no-data-text="暂无可核销学员">
            <template v-slot:item.studentName="{item}">
              <div class="ar-student"><span class="ar-avatar">{{(item.studentName || '学').slice(0,1)}}</span><div class="ar-student-text"><strong :class="{'ar-leave-name':item.classStatus=='2'}">{{item.studentName}}</strong><span v-if="item.classStatus=='2'" class="ar-student-leave">请假</span></div><span v-if="item.studentType=='2'" class="ar-student-tag ar-book">约</span><span v-if="item.studentType=='3'" class="ar-student-tag ar-extra">补</span></div>
            </template>
            <template v-slot:item.courseBalance="{item}">
              <span class="ar-balance" :class="{'ar-balance-negative':Number(item.courseBalance)<0}"><span>{{item.courseBalance}}</span><small v-if="item.consumeType=='2'">元</small><small v-if="item.consumeType=='1'">课时</small></span>
            </template>
            <template v-slot:item.consumeType="{item}"><span class="ar-consume" :class="'ar-consume-'+item.consumeType">{{consumeTypeName(item.consumeType)}}</span></template>
            <template v-slot:item.reduceQty="{item}"><v-text-field class="ar-quantity" type="number" v-model="item.reduceQty" dense outlined hide-details color="#d9363e" :aria-label="item.studentName+'本次课时'" /></template>
            <template v-slot:item.classStatus="{item}"><v-select class="ar-status" :class="'ar-status-'+item.classStatus" :items="approve.classStatusItems" v-model="item.classStatus" item-text="text" item-value="id" dense outlined hide-details color="#d9363e" @change="statusChanged(item)" :aria-label="item.studentName+'上课状态'" /></template>
            <template v-slot:item.reduceAmount="{item}"><span class="ar-deduction"><template v-if="item.consumeType=='2'">{{item.reduceQty * item.classHourPrice}}<small>元</small></template><template v-if="item.consumeType=='1'">{{item.reduceQty}}<small>课时</small></template></span></template>
            <template v-slot:no-data><div class="ar-empty"><v-icon size="40" color="#a8b7c7">mdi-account-group-outline</v-icon><strong>暂无可核销学员</strong><span>请先添加班级学员，并检查学员进班日期是否晚于上课日期。</span></div></template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="ar-footer">
          <v-checkbox class="ar-confirm" v-model="approve.comfirmed" label="确认数据无误" color="#d9363e" dense hide-details />
          <v-spacer />
          <div class="ar-actions"><v-btn outlined color="#586a80" @click="cancel">取消</v-btn><v-btn class="ar-submit" depressed color="#d9363e" dark @click="submitApprove" :disabled="approve.submitting || !approve.comfirmed" :loading="approve.submitting">提交核销</v-btn></div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
	export default {
		name: "approve-record",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			recordId: {
				type: String,
				default: ""
			}

		},
		watch: {
			show(newVal, oldVal) {
				console.log("newVal", newVal);
				this.hideShow = newVal;
				if (this.hideShow) {
					this.approve.comfirmed = false;
					this.approve.studentList = [];
					this.getRecordStudentList(this.recordId);
				}
			}
		},
		data() {
			return {
				loadding: false,
				hideShow: this.show,
				approve: {
					submitting: false,
					comfirmed: false,
					classStatusItems: [{
							id: "1",
							text: "到课"
						},
						{
							id: "2",
							text: "请假"
						},
						{
							id: "3",
							text: "旷课"
						},
					],
					headers: [

						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '课程余额',
							value: 'courseBalance',
							sortable: false
						},
						{
							text: '扣费方式',
							value: 'consumeType',
							sortable: false
						},
						{
							text: '本次课时',
							value: 'reduceQty',
							width: '110',
							sortable: false
						},
						{
							text: '上课状态',
							value: 'classStatus',
							width: '120',
							sortable: false
						},
						{
							text: '本次扣除',
							value: 'reduceAmount',
							width: '100',
							sortable: false
						},
					],
					checkedItems: [], //选中的学生
					studentList: [], //学生列表
					originReduceQty:"1",// 默认扣减课时数
				}
			}
		},
		mounted() {
			console.log("approve-record mounted");
		},
		methods: {
			statusChanged(item){
				console.log(item);
				if (item.classStatus=="2" ||item.classStatus=="3" ){
					item.reduceQty = "0";
				}else if (item.classStatus=="1"){
					item.reduceQty = this.originReduceQty;
				}
			},
			consumeTypeColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "2") {
					color = "success";
				}

				return color;
			},
			consumeTypeName(state) {
				let color = "未知";
				if (state === "1") {
					color = "扣课时";
				} else if (state === "2") {
					color = "扣金额";
				}

				return color;
			},
			cancel() {
				this.$emit("cancel", "");
			},
			submitApprove() {
				//提交核销
				if (!this.recordId) {
					return
				}

				if (!this.approve.comfirmed) {
					this.$noty.error("请先确认数据");
					return
				}

				this.approve.submitting = true;
				let detailList = [];
				this.approve.studentList.forEach((item, index) => {
					item.reduceQty = parseInt(item.reduceQty);
					detailList.push(item);
				});

				// api
				const that = this;
				let url = `/edu/class/record/approve`;
				let postData = {
					id: this.recordId,
					detailList: detailList
				};

				console.log(postData);

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("核销成功");

							that.approve.comfirmed = false;
							that.approve.submitting = false;
							that.$emit("success", "");
							return;
						} else {
							that.approve.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.approve.submitting = false;
						that.$noty.error('网络请求失败');
					}

				});
			},
			getRecordStudentList(recordId) {
				// 获取待核销记录的学生列表

				if (!recordId) {
					return
				}
				this.loadding = true;
				const that = this;
				let url = `/edu/class/record/student/list/` + recordId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.loadding = false;
						that.approve.studentList = response.data["data"] ? response.data["data"] : [];
						
						console.log('students',that.approve.studentList);
						
						// 设置默认扣减课时数 当状态改变为到课时要恢复默认的扣减数
						if (that.approve.studentList.length > 0){
							const student0 = that.approve.studentList[0];
							
							that.originReduceQty = student0.defaultQty;
						}
						
						return
					}
					that.loadding = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			}
		}
	}
</script>

<style lang="scss" scoped src="../assets/styles/approve-record.scss"></style>
